/* eslint-disable prefer-destructuring */
import { Outlet, useLocation } from 'react-router-dom';
import './_layout.scss';

import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Header } from 'components/common/header';
import { Footer } from 'components/common/footer';
import { AnchorLink } from 'components/common/anchorLink';
import { trackProductPageView } from 'libs/adobeAnalytics';
import LoaderSpinner from 'components/atoms/Loader/LoaderSpinner';

export function Layout() {
  const { userInfo } = useSelector((state) => state.user);
  const location = useLocation();
  const trackedPathRef = useRef(null);

  useEffect(() => {
    if (!userInfo || trackedPathRef.current === location.pathname) return;

    const timeout = setTimeout(() => {
      trackProductPageView(userInfo);
      trackedPathRef.current = location.pathname;
    }, 500);

    return () => clearTimeout(timeout);
  }, [location, userInfo]);

  if (!userInfo) {
    return <LoaderSpinner />;
  }

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <a
        href='#main-content'
        className='sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[10001] focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-black'
      >
        Skip to main content
      </a>
      <Header />
      <main className='main' id='main-content' tabIndex={-1}>
        <Outlet />
      </main>

      <AnchorLink />
      <Footer />
    </div>
  );
}
